import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export const CtaEmozionale = () => (
    <section id="cta-emozionale" className="bg-petrol relative overflow-hidden" data-testid="cta-section">
        <div className="pointer-events-none absolute -top-24 left-1/2 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-sage/20 blur-3xl" aria-hidden="true" />
        <div className="max-w-4xl mx-auto px-6 sm:px-12 py-24 md:py-36 text-center relative">
            <motion.div
                initial={{ opacity: 0, scale: 0.94 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                className="mx-auto mb-12 w-40 sm:w-52 overflow-hidden rounded-t-[999px] rounded-b-2xl shadow-2xl shadow-black/40 aspect-[4/5]"
            >
                <img
                    src="/images/foto1.jpg"
                    alt="Opera artistica: un volto che si apre su un corridoio con una chiave, simbolo del percorso interiore"
                    className="h-full w-full object-cover"
                    loading="lazy"
                    data-testid="cta-artwork"
                />
            </motion.div>
            <motion.h2
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="font-serif text-3xl sm:text-4xl lg:text-6xl leading-tight text-cream"
                data-testid="cta-title"
            >
                Forse il momento giusto per iniziare è semplicemente <em className="text-sage-light">adesso</em>.
            </motion.h2>
            <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.15 }}
                className="mt-8 text-base sm:text-lg text-cream/75 leading-relaxed max-w-2xl mx-auto"
            >
                Non è necessario avere tutte le risposte prima di chiedere aiuto. A volte il primo passo consiste semplicemente nel trovare qualcuno con cui iniziare a parlarne.
            </motion.p>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className="mt-12"
            >
                <button
                    data-testid="emotional-cta-book-btn"
                    onClick={() => scrollToId("#contatti")}
                    className="group inline-flex items-center gap-3 rounded-full bg-cream text-petrol px-10 py-5 text-lg font-semibold hover:bg-white hover:shadow-2xl hover:-translate-y-0.5 transition-all duration-300"
                >
                    Contatta il Dott. De Lorenzo
                    <ArrowRight size={20} className="transition-transform duration-300 group-hover:translate-x-1" />
                </button>
            </motion.div>
        </div>
    </section>
);
